export default __webpack_public_path__ + "static/media/resume.0610b9cb.pdf";